import React, { useEffect } from "react"
import { Box, Dialog, DialogContent, styled, Typography, IconButton } from "@mui/material"
import AppButton from "components/StyledComponents/AppButton"
import AppTextField from "components/StyledComponents/AppTextField"
import CloseIcon from "@mui/icons-material/Close"
import { useTheme } from "@mui/system"

const buttonText = {
  CANCEL: "Cancel",
  SAVE: "Save",
  UPDATE: "Update"
}

const StyledDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiPaper-root": {
    backgroundColor: "transparent"
  },
  "& .MuiDialogContent-root": {
    backgroundColor: theme.palette.background.default,
    borderRadius: 12,
    border: "none",
    width: 580,
    padding: 35,
    boxSizing: "border-box"
  }
}))

function ServiceCategoryModal({ open = false, onClose = () => {}, isEdit = false, formik, title }) {
  const theme = useTheme()

  useEffect(() => {
    formik.resetForm()
  }, [open])

  const styles = {
    closeBtn: {
      color: theme.palette.text.primary,
      position: "absolute",
      top: "10px",
      right: "10px",
      backgroundColor: theme.palette.background.main
    }
  }

  return (
    <StyledDialog open={open}>
      <DialogContent>
        <Box className="d-flex justify-content-end">
          <IconButton onClick={() => onClose()} sx={styles.closeBtn}>
            <CloseIcon sx={{ height: "14px", width: "14px" }} />
          </IconButton>
        </Box>
        <Box className="w-100 d-flex justify-content-center mb-2">
          <Typography variant="h2">{title}</Typography>
        </Box>

        <Box flexDirection="column" className="mt-4">
          <React.Fragment>
            <Box className="d-flex justify-content-between w-100 py-2">
              <AppTextField
                id="category"
                name="category"
                fullWidth
                isUpperCase={!false}
                label={`Category`}
                isRequired={true}
                placeholder="Enter Category"
                value={formik.values.category}
                onChange={formik.handleChange}
                error={formik.touched.category && Boolean(formik.errors.category)}
                helperText={formik.errors.category}
              />
            </Box>
          </React.Fragment>
        </Box>
        <Box className="mt-5 d-flex justify-content-around">
          <AppButton
            disabled={Boolean(formik?.errors.category) || formik?.values.category?.length === 0}
            onClick={formik.handleSubmit}
            sx={{ height: "48px", width: 150 }}
            variant="outlined">
            {isEdit ? buttonText.UPDATE : buttonText.SAVE}
          </AppButton>
          <AppButton
            onClick={() => onClose()}
            sx={{ height: "48px", width: 150 }}
            variant="outlined">
            {buttonText.CANCEL}
          </AppButton>
        </Box>
      </DialogContent>
    </StyledDialog>
  )
}

export default ServiceCategoryModal
